__turbopack_context__.v({
  "boxArea": "loading-module-scss-module__A3bXRq__boxArea",
  "grid_loading_box": "loading-module-scss-module__A3bXRq__grid_loading_box",
  "loading": "loading-module-scss-module__A3bXRq__loading",
  "loading-text-opacity": "loading-module-scss-module__A3bXRq__loading-text-opacity",
  "loadingBox": "loading-module-scss-module__A3bXRq__loadingBox",
  "loading_box": "loading-module-scss-module__A3bXRq__loading_box",
  "rotate-loading": "loading-module-scss-module__A3bXRq__rotate-loading",
  "spin": "loading-module-scss-module__A3bXRq__spin",
  "text": "loading-module-scss-module__A3bXRq__text",
});
